import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { FormErrors } from '../types';

interface TwoFactorChallengeFormProps {
  identifierLabel?: string;
  onSubmit: (otp: string) => Promise<void>;
  onBack: () => void;
  isLoading: boolean;
}

const TwoFactorChallengeForm: React.FC<TwoFactorChallengeFormProps> = ({
  identifierLabel,
  onSubmit,
  onBack,
  isLoading,
}) => {
  const [otp, setOtp] = useState('');
  const [errors, setErrors] = useState<FormErrors>({});

  const validate = (): boolean => {
    const code = (otp || '').replace(/\s/g, '');
    const newErrors: FormErrors = {};
    if (!code) newErrors.otp = 'Codul este obligatoriu';
    else if (!/^\d{6}$/.test(code)) newErrors.otp = 'Introdu codul de 6 cifre';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    await onSubmit((otp || '').replace(/\s/g, ''));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="space-y-1">
        <div className="text-sm font-semibold text-foreground">Verificare în doi pași (2FA)</div>
        <div className="text-xs text-muted-foreground">
          Introdu codul din Google Authenticator / Microsoft Authenticator{identifierLabel ? ` pentru ${identifierLabel}` : ''}.
        </div>
      </div>

      <Input
        type="text"
        label="Cod OTP"
        placeholder="ex: 123456"
        inputMode="numeric"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        error={errors.otp}
        required
        disabled={isLoading}
        className="w-full"
      />

      <div className="flex gap-3">
        <Button type="button" variant="outline" onClick={onBack} disabled={isLoading} fullWidth>
          Înapoi
        </Button>
        <Button type="submit" variant="default" loading={isLoading} fullWidth>
          Continuă
        </Button>
      </div>
    </form>
  );
};

export default TwoFactorChallengeForm;

